'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.Dictionaries.edit', [])
  .controller('DictionariesEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/dictionaries/edit/index.js